import EmployeeProfileWidget from './EmployeeProfileWidget';
export default EmployeeProfileWidget;
